import * as swcHelpers from '@swc/helpers';
import { Location } from '@grandvisionhq/api-client';

/**
 * Multi-country getCoordinates workaround. Use api-client's
 * Location.getCoordinates instead, unless location-service is configured with
 * a GOOGLE_MAPS_COUNTRY_RESTRICTION with multiple country codes.
 */ const getCoordinatesMultiCountry = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        var ref;
        const { places  } = yield Location.getPlacePredictionsExtended(apiUrl, {
            place: request.query
        });
        const place = places === null || places === void 0 ? void 0 : places[0];
        if (!place) {
            throw new Error('No matching place found');
        }
        const details = yield Location.getPlaceDetails(apiUrl, {
            id: place.id
        });
        return {
            address: ((ref = place.address) === null || ref === void 0 ? void 0 : ref.join(', ')) || '',
            coordinates: details.coordinates
        };
    });
    return function getCoordinatesMultiCountry(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getCoordinatesMultiCountry };
//# sourceMappingURL=get-coordinates-multi-country.js.map
